module.exports = __webpack_public_path__ + "media/images/lilica/lilica3-1a85d4e6419313d0e90e73db7357c1da.png";